// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var emptyAudioSignal = {
    timestamp: Data_Maybe.Nothing.value,
    samples: [  ]
};
module.exports = {
    emptyAudioSignal: emptyAudioSignal,
    loadAudio: $foreign.loadAudio,
    playAudio: $foreign.playAudio
};
